import { css } from "styled-components";
const Breakpoints = {
  tablet: 768,
  desktop: 992,
};
const Devices = {
  tablet: `(min-width: ${Breakpoints.tablet}px)`,
  desktop: `(min-width: ${Breakpoints.desktop}px)`,
};
const ContainerCss = css`
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  @media ${Devices.desktop} {
    padding-left: 10rem;
    padding-right: 10rem;
  }
`;


export { Breakpoints, ContainerCss, Devices };
